const data_services = [
    {
        iconCSSClass: "ion-ios-monitor",
        title: "Front-end Development",
        description: "Implementing web designs through coding languages like HTML, CSS, JavaScript, Jquery, Typescipt and React. "
    },
    {
        iconCSSClass: "ion-code-working",
        title: "Backend Development",
        description: "Development and addressing server-side web application logic and integration. Writing the web services and APIs with focus on databases, scripting, website architecture."
    },
    {
        iconCSSClass: "ion-ios-cloud",
        title: "Cloud Software Engineer",
        description: "Responsible for any technological duties associated with cloud computing, including design, planning, management, maintenance and support."
    },
    {
        iconCSSClass: "ion-ios-infinite",
        title: "Devops",
        description: "Handling processes, tools, and methodologies to balance needs throughout the software development life cycle, from coding and deployment, to maintenance and updates."
    }
]

export default data_services;